'use client';

/**
 * Autofrance-laddaren på sajten: flaggan (blå, vit, röd) fylls från vänster som en laddningsrad (ägaren 2026-10-08,
 * samma märke som i admin). Raden överst visas efter en kort stund, flaggan i mitten först om det dröjer — annars
 * blinkar den vid varje snabbt klick. Startas av 'af-laddar' (instrumentation-client.ts, regnummeruppslaget) och
 * stängs när adressen byts, av 'af-laddar' stop, eller efter 15 s som skyddsnät.
 * Animerar bredd i stället för clip-path — äldre iPhones (Safari 14) ska också se den.
 */
import { useEffect, useRef, useState } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';

const RANDER = 'linear-gradient(90deg, #0055a4 0 33.34%, #ffffff 33.34% 66.67%, #ef4135 66.67% 100%)';

export function AfLaddare() {
  const [rad, setRad] = useState(false);
  const [flagga, setFlagga] = useState(false);
  const timrar = useRef<ReturnType<typeof setTimeout>[]>([]);
  const sokvag = usePathname();
  const params = useSearchParams();

  const stopp = () => { timrar.current.forEach(clearTimeout); timrar.current = []; setRad(false); setFlagga(false); };
  useEffect(() => {
    const lyssna = (e: Event) => {
      if ((e as CustomEvent).detail === 'stop') { stopp(); return; }
      stopp();
      timrar.current = [setTimeout(() => setRad(true), 150), setTimeout(() => setFlagga(true), 800), setTimeout(stopp, 15_000)];
    };
    window.addEventListener('af-laddar', lyssna);
    return () => { window.removeEventListener('af-laddar', lyssna); stopp(); };
  }, []);
  // Ny adress = framme.
  useEffect(() => { stopp(); }, [sokvag, params]);

  if (!rad) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[100]" role="progressbar" aria-busy="true">
      <div className="h-1 w-full bg-black/5">
        <div className="af-fyll h-full" style={{ backgroundImage: RANDER, backgroundSize: '100vw 100%', backgroundRepeat: 'no-repeat' }} />
      </div>
      {flagga && (
        <div className="fixed left-1/2 top-1/2 h-10 w-[3.75rem] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-md bg-white/70 shadow-lg ring-1 ring-black/10">
          <div className="af-fyll h-full" style={{ backgroundImage: RANDER, backgroundSize: '3.75rem 100%', backgroundRepeat: 'no-repeat' }} />
        </div>
      )}
      <style>{`
        @keyframes af-fyll { 0% { width: 0%; } 85% { width: 100%; } 100% { width: 100%; } }
        .af-fyll { animation: af-fyll 1.6s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) { .af-fyll { animation-duration: 3.2s; } }
      `}</style>
    </div>
  );
}
